/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleHeader from 'base/components/labrador/ArticleHeader';

export const DynamicLabradorArticleHeader: typeof LabradorArticleHeader = (props) => {
    return <ErrorBoundary><LabradorArticleHeader {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleHeaderProps = PropsFromComponent<typeof LabradorArticleHeader>;
